import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

import { VpStripeElementsWrapper } from '../../wrappers/VpStripeElementsWrapper';
import AddCardDialogContent from './AddCardDialogContent';
import { VpDialogTitle, VpDialogContent } from '../../components';

export const VpAddCardDialog = ({ open = false, onClose = null }) => {
  return (
    <Dialog fullWidth onClose={onClose} open={open}>
      <VpDialogTitle leftContent="Update Card" onClose={onClose} />
      <VpDialogContent>
        <VpStripeElementsWrapper>
          <AddCardDialogContent onClose={onClose} />
        </VpStripeElementsWrapper>
      </VpDialogContent>
    </Dialog>
  );
};

VpAddCardDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default VpAddCardDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpAddCardDialog/VpAddCardDialog.jsx